"use client";

import { useTranslations } from "@/lib/hooks/use-translations";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { CheckCircle, XCircle } from "lucide-react";

interface FeedbackModalProps {
  isOpen: boolean;
  onClose: () => void;
  isSuccess: boolean;
  error?: string | null;
}

export function FeedbackModal({ isOpen, onClose, isSuccess, error }: FeedbackModalProps) {
  const { t } = useTranslations();
  
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-white rounded-full h-9 w-9 flex justify-center items-center">
          {isSuccess ? (
              <>
                <CheckCircle className="h-8 w-8 text-green-500" />
              </>
            ) : (
              <>
                <XCircle className="h-8 w-8 text-red-500" />
              </>
          )}
        </div>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
          {isSuccess ? (
              <>
                {t('pages.contact.form.success')}
              </>
            ) : (
              <>
                {t('pages.contact.form.error')}
              </>
            )}
          </DialogTitle>
          {error && (
            <DialogDescription className="text-red-600">
              {error}
            </DialogDescription>
          )}
        </DialogHeader>
        <DialogFooter>
          <Button onClick={onClose}>
            {t('pages.contact.form.close')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
